// Reemplaza TransactionTypeFilter (store global compartido) por un componente aislado.
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeFilterTransactionTypeByProduct,
  reportFilterTransactionTypeByProductSelector,
} from '../../state';
import { TransactionType } from '../../types';
import { SelectFlexSales } from '../selects';

const GCS_BY_PRODUCT_TRANSACTION_TYPES: TransactionType[] = [0, 8, 10, 11, 12, 14, 80, 81].map(
  id => ({ id })
);

const TransactionTypeByProductFilter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const value = useSelector(reportFilterTransactionTypeByProductSelector);

  const handleChange = useCallback(
    (value: TransactionType[]) => dispatch(changeFilterTransactionTypeByProduct(value)),
    [dispatch]
  );

  return (
    <SelectFlexSales
      label={t('table.columns.transaction_type')}
      options={GCS_BY_PRODUCT_TRANSACTION_TYPES}
      getOptionLabel="id"
      value={value}
      onChange={handleChange}
      multiple
    />
  );
};

export default TransactionTypeByProductFilter;
